var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _path11, _g4, _path12, _g5, _path13, _path14, _g6, _path15, _path16, _path17, _g7, _path18, _path19, _path20, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 83,
    viewBox: "0 0 99 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 66,
    width: 4,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0399 66.837H83.1422V69.9384H80.0399V66.837Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 66,
    width: 4,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.591 66.837C80.7344 66.837 80.0399 67.5307 80.0399 68.3881C80.0399 69.2447 80.7344 69.9384 81.591 69.9384C82.4476 69.9384 83.1422 69.2447 83.1422 68.3881C83.1422 67.5307 82.4476 66.837 81.591 66.837Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0399 66.837H83.1422V69.9384H80.0399V66.837Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 51,
    width: 7,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20464 51.9458H0V57.7367H6.20464V51.9458Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 51,
    width: 6,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.206787 51.9685H5.80712V57.5673H0.206787V51.9685Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 51,
    width: 6,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00695 51.9685C1.46064 51.9685 0.206787 53.2208 0.206787 54.7687C0.206787 56.315 1.46064 57.5673 3.00695 57.5673C4.55326 57.5673 5.80712 56.315 5.80712 54.7687C5.80712 53.2208 4.55326 51.9685 3.00695 51.9685Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.206787 51.9687H5.80712V57.5675H0.206787V51.9687Z",
    fill: "#D0BEDD"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 43,
    width: 5,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2376 43.5695H6.20459V47.3336H10.2376V43.5695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 43,
    width: 4,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33917 43.5842H9.97939V47.2234H6.33917V43.5842Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 43,
    width: 4,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1594 43.584C7.1543 43.584 6.33929 44.3979 6.33929 45.4041C6.33929 46.4092 7.1543 47.2231 8.1594 47.2231C9.1645 47.2231 9.97951 46.4092 9.97951 45.4041C9.97951 44.3979 9.1645 43.584 8.1594 43.584Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33893 43.5842H9.97914V47.2234H6.33893V43.5842Z",
    fill: "#D0BEDD"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.624 61.8804C85.624 60.3344 86.8781 59.081 88.4242 59.081C89.9702 59.081 91.2244 60.3344 91.2244 61.8804C91.2244 63.4264 89.9702 64.6798 88.4242 64.6798C86.8781 64.6798 85.624 63.4264 85.624 61.8804Z",
    fill: "#D0BEDD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27405 10.6923C5.27405 9.14622 6.52817 7.89291 8.07421 7.89291C9.62025 7.89291 10.8744 9.14622 10.8744 10.6923C10.8744 12.2383 9.62025 13.4916 8.07421 13.4916C6.52817 13.4916 5.27405 12.2383 5.27405 10.6923Z",
    fill: "#D0BEDD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3104 18.2857C94.3104 17.3434 95.0743 16.5795 96.0167 16.5795C96.959 16.5795 97.723 17.3434 97.723 18.2857C97.723 19.2281 96.959 19.992 96.0167 19.992C95.0743 19.992 94.3104 19.2281 94.3104 18.2857Z",
    fill: "#D0BEDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3799 11.3129C93.3799 9.76682 94.634 8.5135 96.18 8.5135C97.7261 8.5135 98.9802 9.76682 98.9802 11.3129C98.9802 12.8589 97.7261 14.1122 96.18 14.1122C94.634 14.1122 93.3799 12.8589 93.3799 11.3129Z",
    fill: "#D0BEDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 3,
    width: 28,
    height: 33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 3.90469L40.6784 7.6277L35.9949 35.5991L13.7599 31.8761L18.4434 3.90469Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6676 29.6119L27.6634 28.6066C23.3657 27.887 20.4547 23.8051 21.1743 19.5074L22.4793 11.7133C22.5991 10.9979 23.2799 10.5101 23.9953 10.6299L32.0079 11.9716L32.6593 6.73977L20.9681 4.78221C19.5373 4.54263 18.1732 5.51773 17.934 6.94596L15.9765 18.6371C14.776 25.8069 19.6233 32.6039 26.7931 33.8044L35.8853 35.3268L33.6676 29.6119Z",
    fill: "#662D91"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 11,
    width: 28,
    height: 33
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.322 11.4193L85.7573 15.1758L81.0738 43.1472L58.6385 39.3907L63.322 11.4193Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2313 34.5622L69.2356 35.5676C73.5333 36.2872 77.6152 33.3762 78.3348 29.0785L79.6398 21.2844C79.7596 20.569 79.2749 19.8861 78.5594 19.7663L70.5442 18.4242L71.6326 13.2656L83.3264 15.2236C84.752 15.4623 85.7267 16.829 85.4875 18.2572L83.53 29.9484C82.3295 37.1181 75.535 41.9659 68.3653 40.7654L59.2704 39.2426L63.2313 34.5622Z",
    fill: "#662D91"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8934 59.3734C51.8934 59.3734 47.7106 57.5524 49.0299 45.2329L43.6188 44.3269C40.8504 56.4038 36.3052 56.7633 36.3052 56.7633L43.8815 59.3691L51.8934 59.3734Z",
    fill: "#662D91"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 50,
    height: 50
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3705 0L74.3276 7.02525L67.2901 49.0552L25.333 42.0299L32.3705 0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9334 13.4836C69.6899 32.8544 57.7573 47.002 46.2742 45.0793C34.7886 43.1562 28.1179 25.8936 31.3613 6.52281C31.59 5.15702 31.8603 3.81425 32.1705 2.50489C32.4919 1.14394 33.7992 0.252928 35.178 0.483793L71.2894 6.53026C72.6708 6.76156 73.6165 8.0298 73.4772 9.42124C73.3413 10.7598 73.162 12.1178 72.9334 13.4836Z",
    fill: "#662D91"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.783 68.04L56.6533 62.8422C56.8938 61.4062 55.9282 60.049 54.4922 59.8086L33.7061 56.3282C32.2701 56.0877 30.9125 57.0559 30.6721 58.4919L29.8018 63.6897L55.783 68.04Z",
    fill: "#662D91"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8665 73.2127L24.6067 62.8197C24.8471 61.3837 26.2021 60.4151 27.6381 60.6555L58.8172 65.8761C60.2532 66.1165 61.2213 67.4741 60.9809 68.9102L59.2407 79.3032L22.8665 73.2127Z",
    fill: "#4D226D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 69,
    width: 46,
    height: 14
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3177 69.778L63.9387 77.2493L63.0531 82.5381L18.4321 75.0668L19.3177 69.778Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.405 82.3344L19.833 75.3736C19.1176 75.2538 18.6324 74.5735 18.7522 73.8581L19.1874 71.2592C19.3072 70.5438 19.9875 70.0586 20.7029 70.1784L62.2749 77.1392C62.9903 77.259 63.4755 77.9393 63.3557 78.6547L62.9206 81.2536C62.8008 81.969 62.1205 82.4542 61.405 82.3344Z",
    fill: "#4D226D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 56,
    width: 65,
    height: 27
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7368 56.4354L74.0075 66.6945L71.4427 82.0122L10.172 71.7531L12.7368 56.4354Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 57,
    width: 63,
    height: 25
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5511 57.2268L73.5891 68.9377L71.0734 81.8378L11.0328 70.1265L13.5511 57.2268Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_8397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_8397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 54,
    width: 79,
    height: 28
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.50864 54.2877L73.4158 68.903L70.9001 81.8031L-4.02737 67.19L-1.50864 54.2877Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_8397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63077 56.0368L6.65695 59.8271C6.6885 59.9742 6.80418 60.0978 6.95635 60.1474L10.6717 61.4541C11.0271 61.5832 11.0918 62.0754 10.7721 62.2759L7.48435 64.4213C7.3516 64.4953 7.28168 64.6414 7.27115 64.8001L7.1845 68.7358C7.17207 69.1135 6.7296 69.3282 6.43491 69.0917L3.36529 66.628C3.24395 66.5221 3.0909 66.4938 2.94082 66.5436L-0.832249 67.6743C-1.19268 67.7824 -1.52241 67.4196 -1.39292 67.0615L0.00659679 63.3832C0.0557099 63.2336 0.0423757 63.0896 -0.0494519 62.9512L-2.29111 59.7276C-2.50682 59.4027 -2.26627 58.9883 -1.88902 59.0033L2.04872 59.1893C2.20482 59.1993 2.34017 59.1257 2.44303 59.0066L4.81999 55.8796C5.05654 55.5849 5.54085 55.6794 5.63077 56.0368ZM20.1625 58.8711L17.7855 61.998C17.703 62.1233 17.5469 62.1934 17.3912 62.1807L13.4535 61.9948C13.0758 61.9824 12.8322 62.415 13.054 62.7195L15.2926 65.9453C15.3879 66.0629 15.3982 66.2251 15.3487 66.3773L13.9491 70.0556C13.8201 70.4111 14.1494 70.7765 14.5102 70.6658L18.2829 69.5377C18.4334 69.4853 18.586 69.5162 18.7078 69.6195L21.7774 72.0831C22.0717 72.3223 22.5323 72.1106 22.527 71.7273L22.6132 67.7942C22.6237 67.6355 22.6906 67.5076 22.8264 67.4154L26.1146 65.2674C26.4374 65.0487 26.3696 64.5747 26.0142 64.4456L22.2988 63.1389C22.1467 63.0893 22.0488 62.9713 21.999 62.8212L20.9733 59.0283C20.8833 58.6709 20.399 58.5764 20.1625 58.8711ZM35.5227 61.8683L33.1484 64.9956C33.0637 65.1178 32.9102 65.1884 32.7515 65.1779L28.8163 64.9924C28.4387 64.9799 28.1925 65.4121 28.4143 65.7167L30.6533 68.9399C30.7508 69.0605 30.7585 69.2222 30.7094 69.3718L29.3098 73.0502C29.1804 73.4083 29.5096 73.7736 29.8731 73.6633L33.6436 72.5322C33.7937 72.4824 33.9493 72.5112 34.0681 72.6167L37.1377 75.0803C37.4324 75.3168 37.8952 75.1082 37.8899 74.7248L37.9765 70.7892C37.9866 70.6331 38.0509 70.5048 38.1897 70.4104L41.4774 68.265C41.8002 68.0463 41.7325 67.5723 41.377 67.4432L37.6591 66.136C37.5095 66.0869 37.4121 65.9663 37.3597 65.8158L36.3361 62.0259C36.2258 61.6624 35.7415 61.5679 35.5227 61.8683ZM50.8652 64.8598L48.4909 67.9871C48.4058 68.1119 48.2522 68.1825 48.0935 68.172L44.1588 67.9839C43.7812 67.9714 43.535 68.4036 43.7567 68.7082L45.9954 71.934C46.0933 72.052 46.101 72.2137 46.0514 72.3659L44.6519 76.0443C44.5228 76.3998 44.8521 76.7651 45.2156 76.6548L48.9856 75.5263C49.1362 75.4739 49.2914 75.5053 49.4105 75.6081L52.4802 78.0718C52.7744 78.3109 53.2377 78.0997 53.2319 77.7189L53.3186 73.7833C53.3291 73.6246 53.3934 73.4963 53.5318 73.4045L56.8199 71.2565C57.1427 71.0378 57.075 70.5637 56.7195 70.4347L53.0016 69.1275C52.852 69.0784 52.7541 68.9604 52.7018 68.8099L51.6782 65.02C51.5861 64.6595 51.1044 64.5655 50.8652 64.8598ZM66.2281 67.8573L63.8512 70.9843C63.7691 71.1069 63.6129 71.1771 63.4568 71.167L59.5191 70.981C59.1414 70.9686 58.8978 71.4012 59.1196 71.7058L61.3587 74.9289C61.4536 75.0491 61.4638 75.2113 61.4143 75.3635L60.0148 79.0419C59.8857 79.3973 60.215 79.7627 60.5759 79.652L64.3489 78.5213C64.499 78.4715 64.6516 78.5024 64.7734 78.6057L67.843 81.0694C68.1377 81.3059 68.598 81.0968 68.5926 80.7135L68.6788 76.7804C68.6894 76.6217 68.7562 76.4939 68.8925 76.399L72.1802 74.2537C72.503 74.0349 72.4353 73.5609 72.0798 73.4318L68.3645 72.1251C68.2123 72.0755 68.1148 71.9549 68.0651 71.8048L67.0389 68.0145C66.9282 67.6536 66.4465 67.5596 66.2281 67.8573Z",
    fill: "#FFCA55"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconTwo);
export default __webpack_public_path__ + "static/media/tour_icon_two.745caba7eddea9e2871faf9c00884d4b.svg";
export { ForwardRef as ReactComponent };